import { Routes, Route } from "react-router-dom";
import { ComingSoon } from "./pages/ComingSoon";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ForgotPage } from "./pages/ForgotPage";
import { ResetPage } from "./pages/ResetPage";
import { ResetByCodePage } from "./pages/ResetByCodePage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { CabinetPage } from "./pages/CabinetPage";
import { PostNewPage } from "./pages/PostNewPage";
import { PostDetailPage } from "./pages/PostDetailPage";
import { PostEditPage } from "./pages/PostEditPage";
import { PortfolioArchivePage } from "./pages/PortfolioArchivePage";
import { ProfilePage } from "./pages/ProfilePage";
import { YearSummaryPage } from "./pages/YearSummaryPage";

export function App() {
  return (
    <Routes>
      {/* Public — T21 */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/r/:code" element={<RegisterPage />} />
      <Route path="/forgot" element={<ForgotPage />} />
      <Route path="/reset" element={<ResetPage />} />
      <Route path="/reset-by-code" element={<ResetByCodePage />} />

      {/* Cabinet — protected (T22) */}
      <Route
        path="/cabinet"
        element={
          <ProtectedRoute>
            <CabinetPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cabinet/post/new"
        element={
          <ProtectedRoute>
            <PostNewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cabinet/post/:id"
        element={
          <ProtectedRoute>
            <PostDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cabinet/post/:id/edit"
        element={
          <ProtectedRoute>
            <PostEditPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cabinet/portfolio"
        element={
          <ProtectedRoute>
            <PortfolioArchivePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cabinet/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cabinet/year-summary"
        element={
          <ProtectedRoute>
            <YearSummaryPage />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route
        path="*"
        element={<ComingSoon title="Страница не найдена" subtitle="404" />}
      />
    </Routes>
  );
}
